import { Component, OnInit, Input } from '@angular/core';
import { ProcedureTwoService } from '../../services/procedures/procedure-two.service';
import { environment } from '../../../environments/environment';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import {FilesService} from '../../services/files.service';

@Component({
  selector: 'ngx-procedure-two',
  templateUrl: './procedure-two.component.html',
  styleUrls: ['./procedure-two.component.scss'],
})
export class ProcedureTwoComponent implements OnInit {
  aspects: any = {
    air: {
      key: 'air',
      name: 'Aire',
      description: 'Se produce liberación de vapores a la atmósfera.',
    },
    resources: {
      key: 'resources',
      name: 'Recursos',
      description: 'Consumo de Materias Primas (petrolíferos)',
    },
    dangers: {
      key: 'dangers',
      name: 'Residuos Peligrosos',

      description: 'Durante la descarga de combustible se utilizan mangueras y trapos, que se convierten en residuos peligrososal final de su vida útil.',
    },
    floor: {
      key: 'floor',
      name: 'Suelo',
      description: 'Derrame de combustibles por una mala operación durante la descarga de combustible.',
    },
    specialTrash: {
      key: 'specialTrash',
      name: 'Residuos de Manejo Especial y Sólidos Urbanos',

      description: 'Durante la descarga de combustible se utilizan mangueras y trapos, que se convierten en residuos peligrososal final de su vida útil.',
    },
    energy: {
      key: 'energy',
      name: 'Energía',
      description: 'Consumo de energía eléctrica para la operación de los equipos auxiliares.',
    },
    water: {
      key: 'water',
      name: 'Agua',
      description: 'Se consume agua.',
    },
    trash: {
      key: 'trash',
      name: 'Residuos',
      description: 'Se generan residuos.',
    },
  };

  activitiesHelper = [
    'descarga_combustible',
    'suministro_combustible',
    'consumo_materias',
    'mantenimiento',
    'limpieza',
    'trabajos_administrativos',
  ];

  activities = {
    descarga_combustible: {
      key: 'descarga_combustible',
      name: 'Descarga de combustible a tanques',
      aspects: [
        this.aspects.air,
        this.aspects.resources,
        this.aspects.dangers,
        this.aspects.floor,
      ],
    },
    suministro_combustible: {
      key: 'suministro_combustible',
      name: 'Suministro de combustible a vehículos',
      aspects: [
        this.aspects.air,
        this.aspects.resources,
        this.aspects.dangers,
        this.aspects.specialTrash,
        this.aspects.floor,
        this.aspects.water,
      ],
    },
    consumo_materias: {
      key: 'consumo_materias',
      name: 'Consumo de materias primas (petrolíferos)',
      aspects: [
        this.aspects.resources,
      ],
    },
    mantenimiento: {
      key: 'mantenimiento',
      name: 'Mantenimiento a instalaciones y equipos',
      aspects: [
        this.aspects.trash,
        this.aspects.energy,
        this.aspects.air,
        this.aspects.water,
        this.aspects.resources,
      ],
    },
    limpieza: {
      key: 'limpieza',
      name: 'Limpieza de Instalaciones y Áreas',
      aspects: [
        this.aspects.trash,
        this.aspects.water,
      ],
    },
    trabajos_administrativos: {
      key: 'trabajos_administrativos',
      name: 'Actividades Administrativas',
      aspects: [
        this.aspects.trash,
        this.aspects.energy,
        this.aspects.water,
      ],
    },
  };

  frequencyOptions = [
    {
      name: 'Anual',
      value: 1,
    },
    {
      name: 'Semestral',
      value: 2,
    },
    {
      name: 'Mensual',
      value: 3,
    },
    {
      name: 'Semanal',
      value: 4,
    },
    {
      name: 'Diario',
      value: 5,
    },
  ];


  natureOptions = [
    {
      name: 'No genera consecuencias al medio ambiente',
      value: 1,
    },
    {
      name: 'Genera cambios leves en el medio ambiente',
      value: 2,
    },
    {
      name: 'Genera alteraciones importantes al medio ambiente o quejas de la comunidad',
      value: 3,
    },
    {
      name: 'Genera alteraciones significativas al medio ambiente o sanciones de autoridades ambientales',
      value: 4,
    },
    {
      name: 'Genera alteraciones catastróficas al medio ambiente',
      value: 5,
    },
  ];

  magnitudeOptions = [
    {
      name: 'Puntual interno, localizado en un área específica de la instalación',
      value: 1,
    },
    {
      name: 'Puntual interno, localizado en varias áreas de la instalación',
      value: 2,
    },
    {
      name: 'Local o que afectaa toda la instalación',
      value: 3,
    },
    {
      name: 'Extenso o que afecta a las colindancias',
      value: 4,
    },
    {
      name: 'Extenso o que afecta más allá de las colindancias',
      value: 5,
    },
  ];

  legalRequirementsOptions = [
    {
      name: 'No existe requisito',
      value: 1,
    },
    {
      name: 'Requisito a nivel informativo',
      value: 2,
    },
    {
      name: 'Existe Requisito Legal Cumple',
      value: 3,
    },
    {
      name: 'Existe Requisito Legal En mejora',
      value: 4,
    },
    {
      name: 'Existe Requisito Legal No se cumple',
      value: 5,
    },
  ];


  checkboxes = {
    atmosfera: {
      title: 'Emisiones a la atmósfera',
      enviromentalImpact: 'Emisión de contaminantes a la atmósfera (Descarga de combustible a tanques y Suministro de combustible a vehículos)',
      responsable: 'Responsable de la estación de servicio',
      commitmentDate: '',
      edit: true,
      withFile: false,
      prevencion: [
        {
          name: 'Trámite de Licencia de Funcionamiento, y una vez evaluada se deberán cumplir las condicionantes que la autoridad considere pertinentes.',
          value: false,
        },
      ],
      mitigacion: [],
    },
    consumo_materias: {
      title: 'Consumo de materias primas',
      enviromentalImpact: 'Posibles derrames durante operaciones rutinarias (Descarga de combustible al tanque de almacenamiento)',
      responsable: 'Responsable de la estación de servicio',
      commitmentDate: '',
      edit: true,
      withFile: false,
      prevencion: [
        {
          name: 'Elaboración del Procedimiento para la recepción de Auto-tanque y descarga de productos inflamables y combustibles a tanque de almacenamiento',
          value: false,
        },
        {
          name: 'Contar con un programa de mantenimiento preventivo de la maquinaria, equipo e instalaciones.',
          value: false,
        },
        {
          name: 'Contar con el sistema armonizado de identificación y comunicación de peligros y riesgos por sustancias químicas peligrosas y mezclas.',
          value: false,
        },
      ],
      mitigacion: [
        {
          name: 'Disponer de instalaciones, equipo o materiales para contener las sustancias químicas peligrosas, para que, en el caso de derrame de líquidos o fuga de gases, se impida su escurrimiento o dispersión.',
          value: false,
        },
        {
          name: 'Elaborar procedimiento y respuesta para las emergencias (Fuga, derrame, incendio, explosión)',
          value: false,
        },
      ],
    },
    uso_sustancias: {
      title: 'Uso y manejo de sustancias químicas',
      enviromentalImpact: 'Posibles derrames durante operaciones rutinarias (Descarga de combustible a tanques y Suministro de combustible a vehículos.',
      responsable: 'Responsable de la estación de servicio',
      commitmentDate: '',
      withFile: false,
      edit: true,
      prevencion: [
        {
          name: 'Elaboración del Procedimiento para la recepción de Auto-tanque y descarga de productos inflamables y combustibles a tanque de almacenamiento',
          value: false,
        },
        {
          name: 'Contar con un programa de mantenimiento preventivo de la maquinaria, equipo e instalaciones.',
          value: false,
        },
        {
          name: 'Contar con el sistema armonizado de identificación y comunicación de peligros y riesgos por sustancias químicas peligrosas y mezclas.',
          value: false,
        },
        {
          name: 'Elaboración del Procedimiento de etiquetado, bloqueo y candadeo para interrupción de líneas con productos',
          value: false,
        },
      ],
      mitigacion: [
        {
          name: 'Disponer de instalaciones, equipo o materiales para contener las sustancias químicas peligrosas, para que, en el caso de derrame de líquidos o fuga de gases, se impida su escurrimiento o dispersión.',
          value: false,
        },
        {
          name: 'Elaborar procedimiento y respuesta para las emergencias (Fuga, derrame, incendio, explosión)',
          value: false,
        },
      ],
    },
    generacion_residuos: {
      title: 'Generación de residuos peligrosos',
      enviromentalImpact: 'Contaminación al suelo (Suministro de combustible a vehículos).',
      responsable: 'Responsable de la estación de servicio',
      commitmentDate: '',
      withFile: false,
      edit: true,
      prevencion: [
        {
          name: 'Instalación de contenedores específicos para almacenamiento temporal de los residuos.',
          value: false,
        },
        {
          name: 'Almacén de residuos peligrosos de acuerdo a los criterios establecidos en la Ley General para la Prevención y Gestión Integral de los Residuos y su Reglamento',
          value: false,
        },
        {
          name: 'Recolección de residuos peligrosos por una empresa debidamente autorizada.',
          value: false,
        },
      ],
      mitigacion: [
        {
          name: 'Alta como generador de residuos peligrosos.',
          value: false,
        },
      ],
    },
    agua: {
      title: 'Consumo de agua',
      enviromentalImpact: 'Disminución del Recurso Hídrico.',
      responsable: 'Responsable de la estación de servicio',
      commitmentDate: '',
      edit: true,
      withFile: false,
      prevencion: [
        {
          name: 'Campañas de concientización sobre el uso responsable del recurso hídrico',
          value: false,
        },
      ],
      mitigacion: [],
    },
  };

  responsableOptions = [
    {
      name: 'Responsable de la estación de servicio',
      value: 1,
    },
    {
      name: 'Área de mantenimiento',
      value: 2,
    },
    {
      name: 'Responsable Técnico',
      value: 3,
    },
    {
      name: 'Responsable Personal de Mantenimiento',
      value: 4,
    },
    {
      name: 'Encargado de la estación de servicio',
      value: 5,
    },
  ];


  ambientalImpacts = {
    suministroCombustible: {
      activity: 'Suministro de combustible',
      danger: 'No se cuenta con sellos en las válvulas de red de suministro de combustible',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Realizar mantenimiento. (El mantenimiento consiste en asegurar que las válvulas estén selladas y sean las correctas para su instalación.). Registrar en bitácoras las actividades de mantenimiento realizadas.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    almacenamientoCombustibleVapor: {
      activity: 'Almacenamiento de combustible',
      danger: 'Existe acumulación de vapor dentro del tanque de almacenamiento',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Verificar que el diámetro y válvulas de tuberías sean correcta, es decir, que sean de acuerdo con las especificaciones del fabricante. Seguimiento a la revisión de los accesorios y componentes de los tubos de venteo.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    distribucionCombustible: {
      activity: 'Distribución de combustible por tubería en la estación de servicio',
      danger: 'Existe tubería para la distribución de combustible en mal estado',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Realizar las pruebas de hermeticidad de manera anual. Dar seguimiento a los resultados de las pruebas de hermeticidad.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    almacenamientoCombustibleFugas: {
      activity: 'Almacenamiento de combustible',
      danger: 'Existencia de fugas de combustible a través de la pared del tanque',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Verificar cada 30 días que el equipo del sistema de control de inventarios identifique correctamente el\ttanque\tde almacenamiento y que indique el nivel del producto y el contenido de agua. Realizar las pruebas de hermeticidad de manera anual.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    choqueVehiculo: {
      activity: 'Choque de vehículo con dispensario',
      danger: 'Persona en mal estado, ebria o enferma. (Terceros/Clientes)',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Verificar cada 30 días que el equipo del sistema de control de inventarios identifique correctamente el\ttanque\tde almacenamiento y que indique el nivel del producto y el contenido de agua. Realizar las pruebas de hermeticidad de manera anual.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    lavadoPisos: {
      activity: 'Lavado de pisos',
      danger: 'Existencia de superficies resbalosas.',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Realizar un cierre e identificación adecuada del área que está siendo lavada, incluir en el procedimiento la manera de señalización.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    personaFumando: {
      activity: 'Persona fumando o con flama abierta.',
      danger: 'Falta de señalización que indique la prohibición de fumar.',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Reforzar con despachadores el procedimiento de suministro de productos inflamables. Mantener en buen estado los equipos de respuesta a emergencia`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    descargaAuto: {
      activity: 'Descarga de auto tanque',
      danger: 'La tubería de descarga combustible está mal conectada o tiene fuga',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Seguir el procedimiento para la recepción de Auto-tanque y descarga de productos inflamables y combustibles a tanque de almacenamiento establecido por la empresa. Revisión por parte del personal para constatar que los conectores de descarga cuentan con todos sus accesorios.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    medicionCombustible: {
      activity: 'Medición de combustible por sistema de control de inventarios',
      danger: 'El sistema control de inventarios no da datos esperados y/o congruentes',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Mantenimiento al sistema de control de inventarios. Mantener en operación el equipo del sistema de control de inventarios`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    colisionAuto: {
      activity: 'Colisión de auto tanque durante el traslado en sitio o durante la descarga de combustible',
      danger: 'Mal estado del conductor. No se colocaron calzas al AT',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Ubicar claramente el área de los auto-tanques lejos del otro tráfico. Tener asistencia durante el proceso de descarga, además de equipo contraincendios cercano. Verificar que se realice adecuadamente el procedimiento\tde Procedimiento para la recepción de Auto-tanque y descarga de productos inflamables y combustibles a tanque de almacenamiento`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    automovilArranco: {
      activity: 'Automóvil arrancó con la manguera del dispensario aun colocada',
      danger: 'Persona no quiere pagar por el combustible',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Revisión periódica de la válvula break away. Revisión del correcto funcionamiento de los paros de emergencia.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    pruebaSistema: {
      activity: 'Prueba del sistema de paro de emergencia',
      danger: 'Mal funcionamiento del sistema de paro de emergencia',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Realizar revisiones a los sistemas de paro de emergencia para que funcionen de manera correcta.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    generacionFuente: {
      activity: 'Generación de una posible fuente de ignición',
      danger: 'Falla eléctrica',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Realizar las revisiones de las instalaciones eléctricas conforme al programa anual de mantenimiento.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    suministroCombustibleTransporte: {
      activity: 'Suministro de combustible a transporte público con pasajeros.',
      danger: 'Carga de combustible con motor encendido',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Realizar pláticas de concientización para el personal que realiza el suministro de combustible, con la intención de que no realicen el despacho de combustible a vehículos de transporte que cuenten con pasajeros o no apague el motor. Reforzar la capacitación sobre el procedimiento de suministro de productos inflamables y combustibles a vehículos`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    suministroCombustibleVehiculo: {
      activity: 'Suministro de combustible a vehículos',
      danger: 'Uso de celular',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Reforzar la capacitación sobre el procedimiento de suministro de productos inflamables y combustibles a vehículos`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    trabajoPeligroso: {
      activity: 'Trabajos peligrosos con fuente de ignición',
      danger: 'Generación de una posible fuente de ignición que entre en contacto con un derrame de combustible',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [
        {
          value: false,
          name: `Brindar capacitación al personal que realiza los trabajos.`,
          responsable: 'Responsable de la estación de servicio',
        },
        {
          value: false,
          name: `Dar a conocer los procedimientos\tde seguridad para realizar trabajos Peligrosos con fuentes que generen ignición (soldaduras, chispas y/o flama abierta).`,
          responsable: 'Responsable de la estación de servicio',
        },
      ],
    },
    mantenimientoFaldon: {
      activity: 'Mantenimiento de faldón (lavado del faldón, composturas, etc.)',
      danger: 'Uso incorrecto del equipo de protección personal o de los sistemas para realizar trabajos en alturas',
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [
        {
          value: false,
          name: `Brindar capacitación al personal que realiza los trabajos.`,
          responsable: 'Responsable de la estación de servicio',
        },
        {
          value: false,
          name: `Dar a conocer los procedimientos de seguridad para realizar trabajos en alturas con escaleras o plataformas superiores a 1.5 m.`,
          responsable: 'Responsable de la estación de servicio',
        },
        {
          value: false,
          name: `Proporcionar a los trabajadores el equipo de protección personal requerido para realizar los trabajos, y en caso de realizar los trabajos con alguna empresa externa solicitarlo.`,
          responsable: 'Responsable de la estación de servicio',
        },
      ],
    },
    lavadoTanque: {
      activity: 'Lavado de tanque de almacenamiento',
      danger: `No se siguen los requisitos de seguridad para realizar los trabajos en el interior del tanque de almacenamiento.`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [
        {
          value: false,
          name: `Brindar capacitación al personal que realiza los trabajos.`,
          responsable: 'Responsable de la estación de servicio',
        },
        {
          value: false,
          name: `Dar a conocer los procedimientos de seguridad para realizar trabajos de limpieza en el interior del tanque de almacenamiento.`,
          responsable: 'Responsable de la estación de servicio',
        },
        {
          value: false,
          name: `Supervisar que se proporcione a los trabajadores el equipo de protección\tpersonal requerido para realizar los trabajos.`,
          responsable: 'Responsable de la estación de servicio',
        },
      ],
    },
    sobrepresionCompresor: {
      activity: 'Sobrepresión en compresor',
      danger: `Mal funcionamiento del compresor.`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [
        {
          value: false,
          name: `Llevar a cabo el dictamen de recipientes sujetos a presión.`,
          responsable: 'Responsable de la estación de servicio',
        },
        {
          value: false,
          name: `Capacitar al personal responsable de la operación y mantenimiento del equipo.`,
          responsable: 'Responsable de la estación de servicio',
        },
      ],
    },
    asalto: {
      activity: 'Asalto',
      danger: `Asalto con arma de fuego`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
          value: false,
          name: `Contar con plan de respuesta a asalto contar con el directorio de emergencias actualizado.`,
          responsable: 'Responsable de la estación de servicio',
      }],
    },
    inundacion: {
      activity: 'Inundación',
      danger: `Situación potencial de emergencia`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [
        {
          value: false,
          name: `Llevar a cabo los simulacros programados.`,
          responsable: 'Responsable de la estación de servicio',
        },
        {
          value: false,
          name: `Contar con la capacitación requerida para las brigadas de emergencia.`,
          responsable: 'Responsable de la estación de servicio',
        },
      ],
    },
    granizo: {
      activity: 'Granizo',
      danger: `Granizo`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Disminuir posibles zonas de peligro mediante supervisión de áreas`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    sismo: {
      activity: 'Sismo',
      danger: `Sismo`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Llevar acabo los simulacros  programados. Contar con capacitaciones requeridas para la brigada de emergencia.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    tormenta: {
      activity: 'Tormentas eléctricas',
      danger: `Tormentas eléctricas`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [
        {
          value: false,
          name: `Que los brigadistas se encuentren capacitados para responder ante posibles emergencias.`,
          responsable: 'Responsable de la estación de servicio',
        },
        {
          value: false,
          name: `Contar con directorio de emergencia actualizado.`,
          responsable: 'Responsable de la estación de servicio',
        },
      ],
    },
    susceptibilidad: {
      activity: 'Susceptibilidad de ladera',
      danger: `Susceptibilidad de ladera`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Que los brigadistas se encuentren capacitados para responder ante posibles emergencias.`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    sequias: {
      activity: 'Sequias',
      danger: `Sequias`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Que el personal se encuentre capacitado ante posibles situaciones de emergencia y estén al tanto de las medidas correspondientes`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    ondas: {
      activity: 'Ondas cálidas',
      danger: `Ondas cálidas`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Que el personal se encuentre capacitado ante posibles situaciones de emergencia y estén al tanto de las medidas correspondientes`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    ciclones: {
      activity: 'Ciclones tropicales',
      danger: `Ciclones tropicales`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Que el personal se encuentre capacitado ante posibles situaciones de emergencia y estén al tanto de las medidas correspondientes`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    bajasTemperaturas: {
      activity: 'Bajas Temperaturas',
      danger: `Bajas Temperaturas`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Que el personal se encuentre capacitado ante posibles situaciones de emergencia y estén al tanto de las medidas correspondientes`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
    nevadas: {
      activity: 'Nevadas',
      danger: `Nevadas`,
      severity: 1,
      probability: 1,
      detection: 1,
      legalRequirements: 1,
      commitmentDate: '',
      recommendedAction: [{
        value: false,
        name: `Que el personal se encuentre capacitado ante posibles situaciones de emergencia y estén al tanto de las medidas correspondientes`,
        responsable: 'Responsable de la estación de servicio',
      }],
    },
  };

  tableGeneralOfValues = {
    severity: [
      {
        value: 1,
        name: 'Muy poco efecto o casi nulo en los trabajadores, la instalación o el medio ambiente.',
      },
      {
        value: 2,
        name: 'Efecto menor en los trabajadores, es decir, puede producir lesiones moderadas. Efectos menores en la instalación o el medio ambiente.',
      },
      {
        value: 3,
        name: 'Efecto moderado en los trabajadores, es decir, puede producir incapacidades temporales. Efectos moderados en la instalación o el medio ambiente.',
      },
      {
        value: 4,
        name: 'Efecto de peligro potencial en los trabajadores, puede producir incapacidades permanentes o la muerte.\n' +
              'Efectos potenciales en la instalación, puede producir efectos en las colindancias o daños irreversibles en el medio ambiente.',
      },
    ],
    probability: [
      {
        value: 1,
        name: 'Peligro improbable. No existen peligros asociados con la instalación o una instalación similar.',
      },
      {
        value: 2,
        name: 'Peligro poco probable. Existen peligros asociados con una instalación similar.',
      },
      {
        value: 3,
        name: 'Peligro probable. Ha ocurrido en la instalación o ha ocurrido a menudo en una instalación similar.',
      },
      {
        value: 4,
        name: 'El peligro es casi inevitable.',
      },
    ],
    detection: [
      {
        value: 1,
        name: 'El peligro es seguro de detectar.',
      },
      {
        value: 2,
        name: 'El peligro es casi probable de detectar.',
      },
      {
        value: 3,
        name: 'El peligro es moderadamente detectable.',
      },
      {
        value: 4,
        name: 'Casi imposible de detectar el peligro identificado',
      },
    ],
    legalRequirements: [
      {
        value: 1,
        name: 'No es un requisito legal.',
      },
      {
        value: 2,
        name: 'Su incumplimiento generaría una multa.',
      },
      {
        value: 3,
        name: 'Su incumplimiento generaría una clausura parcial.',
      },
      {
        value: 4,
        name: 'Su incumplimiento generaría una clausura total.',
      },
    ],
  };

  defaultResponses = {
    frequency: 1,
    conditionOperation: 1,
    nature: 1,
    magnitude: 1,
    legal_requirement: 1,
  };

  responses = {
    descarga_combustible: {
      answered: false,
      edit: false,
      air: { ...this.defaultResponses },
      resources: { ...this.defaultResponses },
      dangers: { ...this.defaultResponses },
      floor: { ...this.defaultResponses },
    },
    suministro_combustible: {
      answered: false,
      edit: false,
      air: { ...this.defaultResponses },
      resources: { ...this.defaultResponses },
      dangers: { ...this.defaultResponses },
      specialTrash: { ...this.defaultResponses },
      floor: { ...this.defaultResponses },
      water: { ...this.defaultResponses },
    },
    consumo_materias: {
      answered: false,
      edit: false,
      resources: { ...this.defaultResponses },
    },
    mantenimiento: {
      answered: false,
      edit: false,
      trash: { ...this.defaultResponses },
      energy: { ...this.defaultResponses },
      air: { ...this.defaultResponses },
      water: { ...this.defaultResponses },
      resources: { ...this.defaultResponses },
    },
    limpieza: {
      answered: false,
      edit: false,
      trash: { ...this.defaultResponses },
      water: { ...this.defaultResponses },
    },
    trabajos_administrativos: {
      answered: false,
      edit: false,
      trash: { ...this.defaultResponses },
      energy: { ...this.defaultResponses },
      water: { ...this.defaultResponses },
    },
  };

  editAmbientalImpacts = true;
  documents = {
    programaSeguimiento: '',
    matriz: '',
    controlMonitoreo: '',
    evaluacionRiesgos: '',
  };

  state = 'Actividades';
  @Input() stationId;
  savingEnviromental = false;
  savingEvaluation = false;
  savingControlMonitoring = false;
  downloading = false;

  constructor(
    private procedureService: ProcedureTwoService,
    private fileService: FilesService,
  ) { }

  ngOnInit() {
    this.getEnvironmentalImpactsTable();
    this.getEnvironmentalImpactsEvaluation();
    this.getEnvironmentalImpactsControlMonitoring();
    this.generateDocument();
  }

  onChangeTab(event) {
    this.state = event.tabTitle;
  }

  loadImage(evt, activity) {
    if (!evt.target.files.length) return;
    this.checkboxes[activity].image = evt.target.files[0];
    this.checkboxes[activity].withFile = true;
  }

  async getEnvironmentalImpactsTable() {
    this.savingEnviromental = true;
    this.activitiesHelper.forEach(async (activity, index) => {

      const [error, result] = await this.procedureService.getEnvironmentalImpactsTable(this.stationId, activity);
      if (error) return console.error(error);
      if (result.data !== null && result.data.hasOwnProperty('aspects')) {
        this.responses[activity] = result.data.aspects;
        this.responses[activity].answered = true;
        this.responses[activity].edit = false;
      }
      if (index === this.activitiesHelper.length - 1) this.savingEnviromental = false;
    });
  }

  async saveResponses(activity) {
    this.savingEnviromental = true;
    const responses = {
      name: this.activities[activity].name,
      key: activity,
      aspects: this.responses[activity],
    };

    const [error] = await this.procedureService.environmentalImpactsTable(this.stationId, responses, activity);
    if (error) { this.savingEnviromental = false; return this.alert('Oops, intenta más tarde', 'error'); }
    this.getEnvironmentalImpactsTable();
    this.savingEnviromental = false;
    this.alert('Datos guardados con éxito');
  }

  async updateResponses(activity) {
    this.savingEnviromental = true;
    const responses = {
      name: this.activities[activity].name,
      key: activity,
      aspects: this.responses[activity],
    };

    const [error] = await this.procedureService.updateEnvironmentalImpactsTable(this.stationId, responses, activity);
    if (error) { this.savingEnviromental = false; return this.alert('Oops, intenta más tarde', 'error'); }
    this.getEnvironmentalImpactsTable();
    this.savingEnviromental = false;
    this.alert('Datos guardados con éxito');
  }

  async getEnvironmentalImpactsControlMonitoring () {
    this.savingControlMonitoring = true;
    const [error, result] = await this.procedureService.getEnvironmentalImpactsControlMonitoring(this.stationId);
    if (error) return console.error(error);
    for await (const activity of result.data) {
      this.checkboxes[activity.id] = activity;
      this.checkboxes[activity.id].edit = false;
      this.checkboxes[activity.id].withFile = !!(this.checkboxes[activity.id].image);
    }
    this.savingControlMonitoring = false;
  }

  async getEnvironmentalImpactsEvaluation() {
    this.savingEvaluation = true;
    const [error, result] = await this.procedureService.getEnvironmentalImpactsEvaluation(this.stationId);
    this.savingEvaluation = false;
    if (error) return console.error(error);
    if (result.data) {
      this.editAmbientalImpacts = false;
      this.ambientalImpacts = result.data;
    }
  }

  async saveEnvironmentalImpactsEvaluation() {
    this.savingEvaluation = true;
    const [error] = await this.procedureService.saveEnvironmentalImpactsEvaluation(this.stationId, this.ambientalImpacts);
    if (error) { this.savingEvaluation = false; return this.alert('Oops, intenta más tarde', 'error'); }
    this.getEnvironmentalImpactsEvaluation();
    this.savingEvaluation = false;
    this.editAmbientalImpacts = false;
    this.alert('Datos guardados con éxito');
  }

  async saveEnvironmentalImpactsControlMonitoring(activity: any) {
    this.savingControlMonitoring = true;
    const data = new FormData();
    data.append('evaluation', JSON.stringify(this.checkboxes[activity]));
    data.append('file', this.checkboxes[activity].image);
    const [error] = await this.procedureService.saveEnvironmentalImpactsControlMonitoring(this.stationId, activity, data);
    this.savingControlMonitoring = false;
    if (error) return this.alert('Oops, intenta más tarde', 'error');
    this.checkboxes[activity].edit = false;
    this.alert('Datos guardados con éxito');
  }

  async updateEnvironmentalImpactsEvaluation() {
    this.savingEvaluation = true;
    // const [error] = await this.procedureService.updateEnvironmentalImpactsEvaluation(this.stationId, this.ambiental_impacts);
    // if (error) { this.savingEvaluation = false; return this.alert('Oops, intenta más tarde', 'error'); }
    // this.getEnvironmentalImpactsEvaluation();
    // this.savingEvaluation = false;
    // this.editAmbientalImpacts = false;
    // this.alert('Datos guardados con éxito');
  }


  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async generateDocument() {
    this.documents.evaluacionRiesgos = `${environment.baseEndpoint}/filesGeneratorv2/implementation/two/environmental/impacts/four/${this.stationId}`;
    this.documents.programaSeguimiento = `${environment.baseEndpoint}/filesGeneratorv2/implementation/two/environmental/impacts/three/${this.stationId}`;
    this.documents.controlMonitoreo = `${environment.baseEndpoint}/filesGeneratorv2/implementation/two/environmental/impacts/two/${this.stationId}`;
    this.documents.matriz = `${environment.baseEndpoint}/filesGeneratorv2/implementation/two/environmental/impacts/one/${this.stationId}`;
  }

  async downloadFile(url, name) {
    this.downloading = true;
    await this.fileService.downloadFile(url, name.toLowerCase().replace(' ', '_'));
    this.downloading = false;
  }
}
